import { ACTIVITY_FEED_SCOPE_LABELS } from "./constants.js";
import "react";
import { Fragment as Fragment$1, jsx, jsxs } from "react/jsx-runtime";
//#region src/modules/shared/ActivityFeed/ActivityFeedScopeTitles.tsx
var ActivityFeedScopeTitles = ({ listAll = true, scopes }) => {
	function getValuesByKeys() {
		const valuesArray = [];
		if (scopes?.length) {
			for (const key of scopes) if (ACTIVITY_FEED_SCOPE_LABELS[key]) valuesArray.push(ACTIVITY_FEED_SCOPE_LABELS[key]);
		}
		return valuesArray;
	}
	if (!scopes?.length) return null;
	if (!listAll && scopes.length > 1) return /* @__PURE__ */ jsxs("div", {
		className: "flex min-w-0 shrink flex-nowrap",
		children: [/* @__PURE__ */ jsx("div", {
			className: "truncate",
			children: getValuesByKeys()[0]
		}), /* @__PURE__ */ jsxs("span", {
			className: "text-info pl-xxs min-w-fit flex-1",
			children: ["+", getValuesByKeys().length - 1]
		})]
	});
	return /* @__PURE__ */ jsx(Fragment$1, { children: getValuesByKeys().map((scope) => scope).join(", ") });
};
//#endregion
export { ActivityFeedScopeTitles };

//# sourceMappingURL=ActivityFeedScopeTitles.js.map